export enum BroadcastEvent {
  ReduxPersistRehydration = 'ReduxPersistRehydration',
  AccessTokenRenewed = 'AccessTokenRenewed',
  AccessTokenFailure = 'AccessTokenFailure',
  SocketErrorTimeout = 'SocketErrorTimeout',
  SocketReconnectExceed = 'SocketReconnectExceed',
  SocketConnected = 'SocketConnected',
  SocketDisconnected = 'SocketDisconnected',
  ProfileAvatar = 'ProfileAvatar',
  ShowPopup = 'ShowPopup',
  HidePopup = 'HidePopup',
}

export enum SocketEvent {
  Ping = 'Ping',
  UserLogin = 'User.Login',
  UserInvalidSession = 'User.InvalidSession',

  ChatMessageCreated = 'Chat.Message.Created',
  ChatTyping = 'Chat.Typing',
  ChatSetLastReadTime = 'Chat.SetLastReadTime',
  CallSessionUpdated = 'Call.SessionUpdated',
  CallParticipantJoined = 'Call.ParticipantJoined',
  CallParticipantLeft = 'Call.ParticipantLeft',
  CallParticipantRejected = 'Call.ParticipantRejected',
  CallParticipantAlreadyJoined = 'Call.ParticipantAlreadyJoined',

  WebRtcReconnect = 'WebRtc.Reconnect',
  WebRtcOffer2 = 'WebRtc.Offer2',
  WebRtcAnswer2 = 'WebRtc.Answer2',
  WebRtcCandidate = 'WebRtc.Candidate',

  WebRtcCandidateReceived = 'WebRtc.CandidateReceived',

  PingGroupUpdated = 'PingGroup.Updated',


  MediasoupCreateRoom = "mediasoup.CreateRoom",
  MediasoupJoin = "mediasoup.Join",
  MediasoupGetRoomDetails = "mediasoup.GetRoomDetails",
  MediasoupGetProducers = "mediasoup.GetProducers",
  MediasoupGetRouterRtpCapabilities = "mediasoup.GetRouterRtpCapabilities",
  MediasoupCreateWebRtcTransport = "mediasoup.CreateWebRtcTransport",
  MediasoupConnectTransport = "mediasoup.ConnectTransport",
  MediasoupProduce = "mediasoup.Produce",
  MediasoupConsume = "mediasoup.Consume",
  MediasoupProducerClosed = "mediasoup.ProducerClosed",
  MediasoupExitRoom = "mediasoup.ExitRoom",
  MediasoupConsumerClosed = "mediasoup.ConsumerClosed",
  MediasoupNewProducers = "mediasoup.NewProducers",
}
